<template>
  <div class="indicator">
    <div class="bar-signal" :title="`${translate('signal_quality')}: ${signalQuality}/10`">
      <div
        :class="[signalQuality > -1 ? rssiVisibleSignal : '']"
      ></div>
      <div
        :class="[signalQuality > 2 ? rssiVisibleSignal : '']"
      ></div>
      <div
        :class="[signalQuality > 4 ? rssiVisibleSignal : '']"
      ></div>
      <div
        :class="[signalQuality > 6 ? rssiVisibleSignal : '']"
      ></div>
      <div
        :class="[signalQuality > 8 ? rssiVisibleSignal : '']"
      ></div>
    </div>
  </div>
</template>

<script>

export default({
  name: "SignalQualityIndicator",
  data() {
    return {
      isEditModal: false,
      isViewModal: false,
    };
  },
  props: {
    data: Object,
  },
  methods: {
  },
  computed: {
    computedRssi() {
      return Number(this.data.rssi) * 2 - 113;
    },
    signalQuality(){
      const modem = {
        network_reg: this.data.signal,
        rssi: this.data.rssi,
        rsrp: this.data.rsrp,
        sinr: this.data.sinr,
        lte_band: this.data.lte_band
      }
      if (modem.network_reg === "LTE") {
        return 3 +
            (this.computedRssi > -70 ? 3 : (this.computedRssi > -85 ? 2 : (this.computedRssi > -100 ? 1 : 0))) +
            (Number(modem.rsrp) > -80 ? 2 : (Number(modem.rsrp) > -90 ? 1 : 0)) +
            (Number(modem.sinr) >= 10 ? 1 : 0) +
            (Number(modem.lte_band) !== 20 ? 1 : 0);
      } else {
        return (this.computedRssi > -70 ? 4 : (this.computedRssi > -85 ? 3 : (this.computedRssi > -100 ? 1 : 0)));
      }
    },
    rssiVisibleSignal() {
      return {
        "green-bg": this.signalQuality > 8,
        "yellow-bg": this.signalQuality <= 8 && this.signalQuality > 6,
        "orange-bg": this.signalQuality <= 6 && this.signalQuality > 4,
        "red-bg": this.signalQuality <= 4 && this.signalQuality > 2,
        "deepred-bg": this.signalQuality <= 2,
      };
    },
  },
});

</script>

<style scoped lang="scss">
.indicator{
  display: flex;
  align-items: center;
}

.bar-signal {
  display: flex;
  margin-left: 5px;
  div {
    width: 5px;
    height: 15px;
    margin-left: 1px;
    border: 1px solid #bbbbbb;
  }

  .green-bg{
    background-color: #00A254FF;
    border-color: #00A254FF;
  }
  .yellow-bg{
    background-color: rgb(226, 211, 73);
    border-color: rgb(226, 211, 73);
  }
  .orange-bg{
    background-color: orange;
    border-color: orange;
  }
  .red-bg{
    background-color: #EB5757FF;
    border-color: #EB5757FF;
  }
  .deepred-bg{
    background-color: red;
    border-color: red;
  }
}
</style>

